export default __webpack_public_path__ + "static/media/2018-JM.468e52d0.JPG";